export default __webpack_public_path__ + "static/media/social-twitter.18799b63.svg";